var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('iframe',{attrs:{"src":("https://player.vimeo.com/video/" + _vm.mediaId + "?color=dcd5cc"),"width":"640","height":"360","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}}),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e145749a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VimeoPost/VimeoPost.vue
// module id = Rn8r
// module chunks = 1